import React from 'react';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { bentoTeal2, pureWhite } from './colors';
import type { ToothState } from './AddServices.types';

type QuadrantProps = {
  tooth_select: boolean | ToothState;
  num: number | string;
  onSurfaceClick: (num: number | string, surface: string) => void;
};

const Surface = styled('div')<{ selected: boolean }>(({ selected }) => ({
  color: selected ? pureWhite : bentoTeal2,
  backgroundColor: selected ? bentoTeal2 : pureWhite,
  border: `1px solid ${bentoTeal2}`,
  height: 18,
  width: 18,
  margin: 1,
  fontSize: 11,
  cursor: 'pointer',
  textAlign: 'center',
}));

function Quadrant({ tooth_select: toothSelect, num, onSurfaceClick }: QuadrantProps) {
  const selectedSurfaces: Record<'distal' | 'occlusal' | 'buccal' | 'mesial' | 'lingual', boolean> =
    typeof toothSelect === 'object' && toothSelect?.surface_select
      ? {
          distal: toothSelect.surface_select.distal?.selected || false,
          occlusal: toothSelect.surface_select.occlusal?.selected || false,
          buccal: toothSelect.surface_select.buccal?.selected || false,
          mesial: toothSelect.surface_select.mesial?.selected || false,
          lingual: toothSelect.surface_select.lingual?.selected || false,
        }
      : {
          distal: false,
          occlusal: false,
          buccal: false,
          mesial: false,
          lingual: false,
        };

  return (
    <Stack spacing={0}>
      <Stack direction="row" justifyContent="center">
        <Surface selected={selectedSurfaces.buccal} onClick={() => onSurfaceClick(num, 'B')}>
          B
        </Surface>
      </Stack>
      <Stack direction="row" spacing={0}>
        <Surface selected={selectedSurfaces.mesial} onClick={() => onSurfaceClick(num, 'M')}>
          M
        </Surface>
        <Surface selected={selectedSurfaces.occlusal} onClick={() => onSurfaceClick(num, 'O')}>
          O
        </Surface>
        <Surface selected={selectedSurfaces.distal} onClick={() => onSurfaceClick(num, 'D')}>
          D
        </Surface>
      </Stack>
      <Stack direction="row" justifyContent="center">
        <Surface selected={selectedSurfaces.lingual} onClick={() => onSurfaceClick(num, 'L')}>
          L
        </Surface>
      </Stack>
    </Stack>
  );
}

export default Quadrant;
